var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{staticClass:"loading"},[_c('img',{staticClass:"loading-icon",attrs:{"src":require("../../assets/loading.gif")}}),(_vm.msg)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.msg)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }